/**
 * File : 文件
 *

 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/smsg/v1/{organizationId}',
  items: [
    /**
     * 获取列表
     */

    { key: 'getNotices', url: '/notices', method: 'GET' },
    { key: 'deleteNotices', url: '/notices', method: 'DELETE' },
    { key: 'addNotices', url: '/notices', method: 'POST' },
    { key: 'updateNotices', url: '/notices', method: 'PUT' },
    { key: 'detailNotices', url: '/notices/{noticeId}', method: 'GET' },
    // 发布
    { key: 'publishNotices', url: '/notices/{noticeId}/publish', method: 'POST' },
    // 撤消
    { key: 'revokeNotices', url: '/notices/{noticeId}/revoke', method: 'POST' },
  ],
};

export default {
  ...generate(config),
};
